import React from "react";

import { TextInput } from "ds/TextInput";
import { TextInputProps } from "ds/TextInput/src/types";
import { Icon } from "ds/icons";

export const Search = ({ search }: { search?: Omit<TextInputProps, "size" | "variation"> }) =>
  search ? <TextInput placeholder="Search" icon={<Icon name="SearchSmIcon" />} size="small" {...search} /> : null;
